import { useTranslation } from '@web_opxp/features';
import { formatDateToString } from '../../../base/dateUtils';
import { ISubscriptionStatusProps } from '../../types';
import NonTerminatable from '../NonTerminatable';
import SubscriptionStatusBadge from '../SubscriptionStatusBadge';
import ProductLabel from './labels/ProductLabel';
import SubscriptionLabel from './labels/SubscriptionLabel';

export default function PausedStatus({ subscription }: Readonly<ISubscriptionStatusProps>) {
  const { productId, createdAt, updatedAt, secondProductId, status } = subscription;
  const { language } = useTranslation();

  const fCreatedAt = formatDateToString(createdAt, language);
  const fUpdatedAt = formatDateToString(updatedAt, language);

  return (
    <>
      <SubscriptionStatusBadge status={status} />
      <ProductLabel productId={productId} family={!!secondProductId} />
      <SubscriptionLabel labelLocaId="manage:Manage.Subscription.Started" value={fCreatedAt} />
      <SubscriptionLabel labelLocaId="manage:Manage.Subscription.PausedSince" value={fUpdatedAt} />
      <SubscriptionLabel labelLocaId="manage:Manage.Subscription.NextCharge" value="-" />
      <NonTerminatable show={true} />
    </>
  );
}
